var parseEnvNumber = function (value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};
export var MIN_WAGER_VALUE = parseEnvNumber(process.env.REACT_MIN_WAGER_VALUE, 100);
export var MAX_WAGER_VALUE = parseEnvNumber(process.env.REACT_MAX_WAGER_VALUE, 1000);
export var MIN_WAGER_PER_BET_LINE_VALUE = parseEnvNumber(process.env.REACT_MIN_WAGER_PER_BET_LINE_VALUE, 1);
